import { Modal } from "shared/ui/modal";
import { Button } from "shared/ui/button";
import styles from "./DisabledElementModal.module.scss";

export const DisabledElementModal = ({ isModalOpen, open, close, toggle }) => {
  return (
    <Modal isModalOpen={isModalOpen} open={open} close={close} toggle={toggle}>
      <div className={styles.modalContent}>
        <p className={styles.modalContent__title}>Уже совсем скоро!</p>
        <p className={styles.modalContent__text}>
          Данный раздел сайта находится в разработке. Спасибо, что остаетесь с
          нами.
        </p>
        <div className={styles.modalContent__button}>
          <Button variant="primary" size="large" onClick={close}>
            Закрыть
          </Button>
        </div>
      </div>
    </Modal>
  );
};
